import { render, staticRenderFns } from "./cadastroEmpenho.vue?vue&type=template&id=e85c8ba6"
import script from "./cadastroEmpenho.vue?vue&type=script&lang=js"
export * from "./cadastroEmpenho.vue?vue&type=script&lang=js"
import style0 from "./cadastroEmpenho.vue?vue&type=style&index=0&id=e85c8ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports